/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "promotions-management",
	data() {
		return {
			promotions: [],
			promotionsHeadings: [
				{
					text: "Promotion",
					field: "promotionName"
				},
				{
					text: "Promotion Description",
					field: "promotionDescription"
				},
				{
					text: "Discount Amount",
					field: "discountAmountAsString"
				},
				{
					text: "Active From",
					field: "effectiveFromDateString"
				},
				{
					text: "Active To",
					field: "effectiveToDateString"
				},
				{
					text: "Is Active",
					field: "isActive"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			actions: [],
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive"
			},
			promotionMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactivePromotionModal",
				heading: "Mark Promotion As Active/Inactive",
				isActive: null,
				promotionId: null
			},
			customerMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markAsActiveInactiveCustomerModal",
				heading: "Mark Customer As Active/Inactive",
				isActive: null,
				companyId: null
			},
			promotion:{
				promotion: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				promotionDescription: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				discountAmount: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				activeFrom: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				activeTo: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				isActive: {
					value: null,
					hasError: false,
					errorMessage: null
				}
			},
			filterStateChanged: false,
			filter:{
				fromDateCreated: null,
				toDateCreated: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				gender: 0,
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getPromotions(){
			this.loading = true;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
				effectiveFromDate: this.filter.fromDateCreated === null ? null : moment(this.filter.fromDateCreated).format("DD/MM/YYYY"),
				effectiveToDate: this.filter.toDateCreated === null ? null : moment(this.filter.toDateCreated).format("DD/MM/YYYY"),
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize
			};
			rewardsService.getPromotions(request).then(
				response => {
					if(response.status === 200){
						this.promotions = response.data.result;
						if(response.data.pagingInfo !== null){
							this.pagingDetails.pageNumber = response.data.pagingInfo.thisPage;
							this.pagingDetails.totalPages = response.data.pagingInfo.totalPages;
						}
						for(let i = 0; i < this.promotions.length; i++){
							this.promotions[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit,
									elementId: "btnEditPromotionAction"
								},
								{
									name: this.promotions[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive,
									elementId: "btnMarkAsActiveOrInactivePromotionAction"
								}
							];
							this.promotions[i].discountAmountAsString = currencyHelper.numberToCurrency(this.promotions[i].discountAmount);
						}
						this.filterStateChanged = false;
						this.promotions = dataTableHelper.castFieldValues(this.promotions);
					}
					this.loading = false;
				}
			);
		},
		onAddNewPromotionClick(){
			this.$router.push("/campaignManagement/promotionsManagement/addPromotion");
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.pagingDetails.pageNumber = 1;
			this.pagingDetails.totalPages = 1;
			this.getPromotions();
		},
		onDateFilterClearClick(){
			console.log("clear clicked");
			this.filter.toDateCreated = null;
			this.filter.fromDateCreated = null;
			this.filterStateChanged = true;
		},
		onToDateCreatedSelect(date){
			this.filter.toDateCreated = date;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onFromDateCreatedSelect(date){
			this.filter.fromDateCreated = date;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onPagingUpdated(pagingInfo){
			console.log("pagingInfo", pagingInfo)
			this.pagingDetails.pageNumber = pagingInfo.pageNumber;
			this.getPromotions();
		},
		onPromotionActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					this.$router.push("/campaignManagement/promotionsManagement/editPromotion/" + actionAndData.data.promotionId)
					break;
				case this.actionKeys.markAsActiveInactive:
					this.promotionMarkAsActiveInactiveModal.showModal = true;
					this.promotionMarkAsActiveInactiveModal.promotionId = actionAndData.data.promotionId;
					this.promotionMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.promotionMarkAsActiveInactiveModal.heading = "Mark Promotion As " + (this.promotionMarkAsActiveInactiveModal.isActive ? "Inactive - " : "Active - ") + actionAndData.data.promotion;
					break;
			}
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			this.promotionMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				promotionId: this.promotionMarkAsActiveInactiveModal.promotionId,
				isActive: markAsActive
			};
			rewardsService.markPromotionAsActiveOrInActive(request).then(
				response => {
					if(response.status === 200){
						this.getPromotions();
						this.promotionMarkAsActiveInactiveModal.showModal = false;
						this.promotionMarkAsActiveInactiveModal.isActive = true;
						this.promotionMarkAsActiveInactiveModal.promotionId = null;
					}
					this.promotionMarkAsActiveInactiveModal.isSaving = false;
				}
			);
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Promotions");
			breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Promotions");
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getPromotions();
	}
};